import {
    Box,
    Button,
    Grid,
    makeStyles,
    TextField,
    Typography,
} from "@material-ui/core";
import {Close} from "@material-ui/icons";
import React from "react";
import {
    Controller,
    useFieldArray,
    useWatch
} from "react-hook-form";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import UploadImage from "../../UploadImage";
import {
    ToggleButton,
    ToggleButtonGroup
} from "@material-ui/lab";

const bannerDefaultValue = {
    is_video: false,
    status: 0,
    localizations: {
        en: {
            title: "",
            image: "",
            url: ""
        },
        tc: {
            title: "",
            image: "",
            url: ""
        }
    }
};

const useStyles = makeStyles((theme) => ({
    bannerBlk: {
        background: "#FFFFFF",
        marginBottom: "20px",
    },
    bannerBlkHeader: {
        background: "#EDEEF0",
        borderLeft: "3px solid #9D3030",
        fontWeight: "bold",
        fontSize: "14px",
        lineHeight: "16px",
        padding: "12px 13px",
    },
    bannerBlkBody: {
        border: "1px solid #CCCCCC",
        borderTop: "0px",
        padding: "20px 13px",
    },
    deleteBtn: {
        margin: "0",
        padding: "0",
        minWidth: "initial",
    },
    input: {
        width: "100%",
        "& button": {
            fontSize: "13px",
            lineHeight: "15px",
        },
    },
}));

const BannerBlock = ({
                         control,
                         index,
                         classes,
                         disabled,
                         remove,
                         data,
                         setValue,
                         getValues
                     }) => {

    return (
        <>
            <Grid
                container
                className={classes.bannerBlkHeader}
                xs={12}
                alignItems="center"
                justify="space-between"
            >
                <span>Selected Banner {index + 1}</span>
                {disabled || (
                    <Button className={classes.deleteBtn}
                            onClick={() => remove(index)}>
                        <Close style={{
                            fontSize: "14px",
                            lineHeight: "16px"
                        }}/>
                    </Button>
                )}
            </Grid>
            <Box className={classes.bannerBlkBody}>
                <Grid container spacing={3}
                      direction="column">
                    <Grid container item xs={12}>
                        <Grid item xs={6}>
                            <Controller
                                defaultValue={data?.localizations.en.title}
                                name={`filmPrevues[${index}].localizations.en.title`}
                                control={control}
                                render={({
                                             field: {
                                                 value,
                                                 onChange,
                                                 ...rest
                                             },
                                             fieldState: {error},
                                         }) => (
                                    <TextField
                                        label="Title (English)"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        value={value}
                                        onChange={(event) => {
                                            setValue(`filmPrevues[${index}].localizations.en.title`, event.target.value);
                                        }}
                                        {...rest}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <Controller
                                defaultValue={data?.localizations.tc.title}
                                name={`filmPrevues[${index}].localizations.tc.title`}
                                control={control}
                                render={({
                                             field: {
                                                 value,
                                                 onChange,
                                                 ...rest
                                             },
                                             fieldState: {error},
                                         }) => (
                                    <TextField
                                        label="Title (Traditional Chinese)"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        value={value}
                                        onChange={(event) => {
                                            setValue(`filmPrevues[${index}].localizations.tc.title`, event.target.value);
                                        }}
                                        {...rest}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12}>
                        <Grid item xs={6}>
                            <UploadImage
                                name={`filmPrevues[${index}].localizations.en.image`}
                                data={data}
                                embeddedName='localizations.en.image'
                                control={control}
                                Controller={Controller}
                                setValue={setValue}
                                getValues={getValues}
                                disabled={disabled}
                                uploadLabel="Upload Image"
                                changeLabel="Change Image"
                                uploadFolder="FILMPREVUE"
                            />
                        </Grid>
                    </Grid>

                    {/* <Box fontWeight={900}
                         fontSize={13} mt={1}
                         ml={3} width="100%">
                        <Typography variant="p">is
                            Video</Typography>
                    </Box>

                    <Grid item xs={4}
                          style={{marginLeft: "8px"}}>
                        <Controller
                            defaultValue={data?.is_video}
                            control={control}
                            name={`filmPrevues[${index}].is_video`}
                            render={({
                                         field: {
                                             value,
                                             onChange,
                                             ...rest
                                         },
                                         fieldState: {error},
                                     }) => (
                                <ToggleButtonGroup
                                    {...rest}
                                    value={value}
                                    onChange={(event, newFormats) => {
                                        if (newFormats !== null) {
                                            onChange(newFormats);
                                        }
                                    }}
                                    exclusive
                                    aria-label="Status"
                                    className={classes.input}
                                >
                                    <ToggleButton
                                        value={true}
                                        aria-label="Active"
                                        style={{width: "50%"}}
                                    >
                                        Active
                                    </ToggleButton>
                                    <ToggleButton
                                        value={false}
                                        aria-label="Inactive"
                                        style={{width: "50%"}}
                                    >
                                        Inactive
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            )}
                        />
                    </Grid>

                    <Grid container item xs={12}>
                        <Grid item xs={6}>
                            <Controller
                                defaultValue={data?.localizations.en['video_url']}
                                name={`filmPrevues[${index}].localizations.en.video_url`}
                                control={control}
                                render={({
                                             field: {
                                                 value,
                                                 onChange,
                                                 ...rest
                                             },
                                             fieldState: {error},
                                         }) => (
                                    <TextField
                                        label="Video Url (English)"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        value={value}
                                        onChange={(event) => {
                                            setValue(`filmPrevues[${index}].localizations.en.video_url`, event.target.value);
                                        }}
                                        {...rest}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <Controller
                                defaultValue={data?.localizations.tc['video_url']}
                                name={`filmPrevues[${index}].localizations.tc.video_url`}
                                control={control}
                                render={({
                                             field: {
                                                 value,
                                                 onChange,
                                                 ...rest
                                             },
                                             fieldState: {error},
                                         }) => (
                                    <TextField
                                        label="Video Url (Traditional Chinese)"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        value={value}
                                        onChange={(event) => {
                                            setValue(`filmPrevues[${index}].localizations.tc.video_url`, event.target.value);
                                        }}
                                        {...rest}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid> */}
                    <Box fontWeight={900}
                         fontSize={13} mt={1}
                         ml={3} width="100%">
                        <Typography variant="p">
                            Status</Typography>
                    </Box>
                    <Grid item xs={4} style={{marginLeft: "8px"}}>
                        <Controller
                            defaultValue={data?.status}
                            control={control}
                            name={`filmPrevues[${index}].status`}
                            render={({
                                         field: {
                                             value,
                                             onChange,
                                             ...rest
                                         },
                                         fieldState: {error},
                                     }) => (
                                <ToggleButtonGroup
                                    {...rest}
                                    value={value}
                                    onChange={(event, newFormats) => {
                                        if (newFormats !== null) {
                                            onChange(newFormats);
                                        }
                                    }}
                                    exclusive
                                    aria-label="Status"
                                    className={classes.input}
                                >
                                    <ToggleButton
                                        value={1}
                                        aria-label="Active"
                                        style={{width: "50%"}}
                                    >
                                        Active
                                    </ToggleButton>
                                    <ToggleButton
                                        value={0}
                                        aria-label="Inactive"
                                        style={{width: "50%"}}
                                    >
                                        Inactive
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            )}
                        />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export default function BannerSections(props) {
    const {
        control,
        setValue,
        getValues,
        disabled,
    } = props;

    const classes = useStyles();

    const {fields, append, remove} = useFieldArray({
        control,
        name: "filmPrevues"
    })

    return (
        <>{JSON.stringify(fields)}
            {fields.map((data, index) => (
                <div className={classes.bannerBlk}
                     key={data.id}>
                    <BannerBlock
                        {...{
                            control,
                            index,
                            classes,
                            disabled,
                            remove,
                            data,
                            setValue,
                            getValues,
                        }}
                    />
                </div>
            ))}
            {disabled || (
                <Button
                    type="button"
                    onClick={() => {
                        append(bannerDefaultValue);
                    }}
                    style={{
                        color: "#306F9D",
                        margin: "5px 0",
                    }}
                >
                    <AddCircleIcon/>
                    Add Banner
                </Button>
            )}
        </>
    );
}